/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_2_DescInputs */

const en_mk_studio_2_desc = /** @type {(inputs: Mk_Studio_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilingual, versioned, with your agency’s logo and colours. Built from the same PRD and estimate.`)
};

const id_mk_studio_2_desc = /** @type {(inputs: Mk_Studio_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dwibahasa, berversi, logo dan warna agensimu. Dibuat dari PRD dan estimasi yang sama.`)
};

/**
* | output |
* | --- |
* | "Bilingual, versioned, with your agency’s logo and colours. Built from the same PRD and estimate." |
*
* @param {Mk_Studio_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_2_desc = /** @type {((inputs?: Mk_Studio_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_2_desc(inputs)
	return en_mk_studio_2_desc(inputs)
});